import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { APPLICATION_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_LIST = '_LOAD_LIST';
export const LOAD_LIST_ID = '_LOAD_LIST_ID';
export const LOAD_AWAIT_DOCUMENTS_LIST_ID = 'LOAD_AWAIT_DOCUMENTS_LIST_ID';
export const CREATE_APPLICATION = '_CREATE_APPLICATION';
export const LOAD_APPLICATION_BY_ID = '_LOAD_APPLICATION_BY_ID';
export const EDIT_APPLICATION_BY_ID = '_EDIT_APPLICATION_BY_ID';
export const DELETE_APPLICATION = '_DELETE_APPLICATION';
export const RESTORE_APPLICATION = '_RESTORE_APPLICATION';
export const ASSIGN_APPLICATION_BY_ID = '_ASSIGN_APPLICATION_BY_ID';
export const ARCHIVE_APPLICATION = '_ARCHIVE_APPLICATION';
export const UNARCHIVE_APPLICATION = '_UNARCHIVE_APPLICATION';
export const LOAD_APPLICATION_STATUS = '_LOAD_APPLICATION_STATUS';
export const LOAD_SMEV_CHECK_LIST = '_LOAD_SMEV_CHECK_LIST';
export const LOAD_LEGAL_ENTITY_FORM_LIST = '_LOAD_LEGAL_ENTITY_FORM_LIST';
export const ACCEPT_APPLICATION = '_ACCEPT_APPLICATION';
export const RETURN_APPLICATION = '_RETURN_APPLICATION';
export const DENIED_APPLICATION = '_DENIED_APPLICATION';
export const SUSPENDED_APPLICATION = '_SUSPENDED_APPLICATION';
export const ANNULMENT_APPLICATION = '_ANNULMENT_APPLICATION';
export const SMEV_CHECK_ALL_APPLICATION = '_SMEV_CHECK_ALL_APPLICATION';
export const SMEV_CHECK_APPLICATION = '_SMEV_CHECK_APPLICATION';
export const LOAD_APPLICATION_HISTORY = '_LOAD_APPLICATION_HISTORY';
export const LOAD_AWAIT_DOCUMENT = '_LOAD_AWAIT_DOCUMENT';
export const LOAD_DOCUMENT_BY_ID = '_LOAD_DOCUMENT_BY_ID';
export const DELETE_DOCUMENT = '_DELETE_DOCUMENT';
export const GROUP_SIGN_FILE = '_GROUP_SIGN_FILE';
export const GROUP_DELETE_FILE = '_GROUP_DELETE_FILE';
export const UN_ASSIGN_APPLICATION_BY_ID = '_UN_ASSIGN_APPLICATION_BY_ID';
export const REVIEW_APPLICATION = '_REVIEW_APPLICATION';
export const GENERATE_DOCX = '_GENERATE_DOCX';
export const APPLICATION_FIELDS_VALIDATION = '_APPLICATION_FIELDS_VALIDATION';
export const SEARCH_INFO_BY_PARAM = '_SEARCH_INFO_BY_PARAM';
export const EXPORT_APPLICATION = '_EXPORT_APPLICATION';
export const LOAD_APPLICANT_LIST = '_LOAD_APPLICANT_LIST';
export const ACCEPT_APPLICANT = '_ACCEPT_APPLICANT';
export const BATCH_COMMAND = 'BATCH_COMMAND';
export const BACH_COMMAND = 'BACH_COMMAND';
export const LOAD_PREVIEW_DOCUMENT = '_LOAD_PREVIEW_DOCUMENT';
export const REGISTER_MAIS_EGU = '_REGISTER_MAIS_EGU';
export const MAIS_EGU_HISTORY = '_MAIS_EGU_HISTORY';
export const LOAD_REPRESENTATIVE_LIST = '_LOAD_REPRESENTATIVE_LIST';

export const loadApplicationList = createDeferredAction(APPLICATION_MODULE + LOAD_LIST);
export const loadApplicationListBegin = createDeferredAction(APPLICATION_MODULE + LOAD_LIST + BEGIN);
export const loadApplicationListSuccessful = createAction(APPLICATION_MODULE + LOAD_LIST + SUCCESSFUL);
export const loadApplicationListFailed = createAction(APPLICATION_MODULE + LOAD_LIST + FAILED);

export const loadApplicationStatus = createDeferredAction(APPLICATION_MODULE + LOAD_APPLICATION_STATUS);
export const loadApplicationStatusBegin = createDeferredAction(APPLICATION_MODULE + LOAD_APPLICATION_STATUS + BEGIN);
export const loadApplicationStatusSuccessful = createAction(APPLICATION_MODULE + LOAD_APPLICATION_STATUS + SUCCESSFUL);
export const loadApplicationStatusFailed = createAction(APPLICATION_MODULE + LOAD_APPLICATION_STATUS + FAILED);

export const createApplication = createDeferredAction(APPLICATION_MODULE + CREATE_APPLICATION);
export const createApplicationSuccessful = createAction(APPLICATION_MODULE + CREATE_APPLICATION + SUCCESSFUL);
export const createApplicationFailed = createAction(APPLICATION_MODULE + CREATE_APPLICATION + FAILED);

export const loadApplicationById = createDeferredAction(APPLICATION_MODULE + LOAD_APPLICATION_BY_ID);
export const loadApplicationByIdSuccessful = createAction(APPLICATION_MODULE + LOAD_APPLICATION_BY_ID + SUCCESSFUL);
export const loadApplicationByIdFailed = createAction(APPLICATION_MODULE + LOAD_APPLICATION_BY_ID + FAILED);
export const loadApplicationByIdClear = createDeferredAction(APPLICATION_MODULE + LOAD_APPLICATION_BY_ID + CLEAR);

export const assignApplicationById = createDeferredAction(APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID);
export const assignApplicationByIdSuccessful = createAction(APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID + SUCCESSFUL);
export const assignApplicationByIdFailed = createAction(APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID + FAILED);

export const unAssignApplicationById = createDeferredAction(APPLICATION_MODULE + UN_ASSIGN_APPLICATION_BY_ID);
export const unAssignApplicationByIdSuccessful = createAction(APPLICATION_MODULE + UN_ASSIGN_APPLICATION_BY_ID + SUCCESSFUL);
export const unAssignApplicationByIdFailed = createAction(APPLICATION_MODULE + UN_ASSIGN_APPLICATION_BY_ID + FAILED);

export const editApplicationById = createDeferredAction(APPLICATION_MODULE + EDIT_APPLICATION_BY_ID);
export const editApplicationByIdSuccessful = createAction(APPLICATION_MODULE + EDIT_APPLICATION_BY_ID + SUCCESSFUL);
export const editApplicationByIdFailed = createAction(APPLICATION_MODULE + EDIT_APPLICATION_BY_ID + FAILED);

export const deleteApplication = createDeferredAction(APPLICATION_MODULE + DELETE_APPLICATION);
export const deleteApplicationSuccessful = createAction(APPLICATION_MODULE + DELETE_APPLICATION + SUCCESSFUL);
export const deleteApplicationFailed = createAction(APPLICATION_MODULE + DELETE_APPLICATION + FAILED);

export const restoreApplication = createDeferredAction(APPLICATION_MODULE + RESTORE_APPLICATION);
export const restoreApplicationSuccessful = createAction(APPLICATION_MODULE + RESTORE_APPLICATION + SUCCESSFUL);
export const restoreApplicationFailed = createAction(APPLICATION_MODULE + RESTORE_APPLICATION + FAILED);

export const archiveApplication = createDeferredAction(APPLICATION_MODULE + ARCHIVE_APPLICATION);
export const archiveApplicationSuccessful = createAction(APPLICATION_MODULE + ARCHIVE_APPLICATION + SUCCESSFUL);
export const archiveApplicationFailed = createAction(APPLICATION_MODULE + ARCHIVE_APPLICATION + FAILED);

export const unarchiveApplication = createDeferredAction(APPLICATION_MODULE + UNARCHIVE_APPLICATION);
export const unarchiveApplicationSuccessful = createAction(APPLICATION_MODULE + UNARCHIVE_APPLICATION + SUCCESSFUL);
export const unarchiveApplicationFailed = createAction(APPLICATION_MODULE + UNARCHIVE_APPLICATION + FAILED);

export const loadSmevCheckList = createDeferredAction(APPLICATION_MODULE + LOAD_SMEV_CHECK_LIST);
export const loadSmevCheckListSuccessful = createAction(APPLICATION_MODULE + LOAD_SMEV_CHECK_LIST + SUCCESSFUL);
export const loadSmevCheckListFailed = createAction(APPLICATION_MODULE + LOAD_SMEV_CHECK_LIST + FAILED);

export const acceptApplication = createDeferredAction(APPLICATION_MODULE + ACCEPT_APPLICATION);
export const acceptApplicationSuccessful = createAction(APPLICATION_MODULE + ACCEPT_APPLICATION + SUCCESSFUL);
export const acceptApplicationFailed = createAction(APPLICATION_MODULE + ACCEPT_APPLICATION + FAILED);

export const returnApplication = createDeferredAction(APPLICATION_MODULE + RETURN_APPLICATION);
export const returnApplicationSuccessful = createAction(APPLICATION_MODULE + RETURN_APPLICATION + SUCCESSFUL);
export const returnApplicationFailed = createAction(APPLICATION_MODULE + RETURN_APPLICATION + FAILED);

export const deniedApplication = createDeferredAction(APPLICATION_MODULE + DENIED_APPLICATION);
export const deniedApplicationSuccessful = createAction(APPLICATION_MODULE + DENIED_APPLICATION + SUCCESSFUL);
export const deniedApplicationFailed = createAction(APPLICATION_MODULE + DENIED_APPLICATION + FAILED);

export const suspendedApplication = createDeferredAction(APPLICATION_MODULE + SUSPENDED_APPLICATION);
export const suspendedApplicationSuccessful = createAction(APPLICATION_MODULE + SUSPENDED_APPLICATION + SUCCESSFUL);
export const suspendedApplicationFailed = createAction(APPLICATION_MODULE + SUSPENDED_APPLICATION + FAILED);

export const annulmentApplication = createDeferredAction(APPLICATION_MODULE + ANNULMENT_APPLICATION);
export const annulmentApplicationSuccessful = createAction(APPLICATION_MODULE + ANNULMENT_APPLICATION + SUCCESSFUL);
export const annulmentApplicationFailed = createAction(APPLICATION_MODULE + ANNULMENT_APPLICATION + FAILED);

export const smevCheckApplication = createDeferredAction(APPLICATION_MODULE + SMEV_CHECK_APPLICATION);
export const smevCheckApplicationSuccessful = createAction(APPLICATION_MODULE + SMEV_CHECK_APPLICATION + SUCCESSFUL);
export const smevCheckApplicationFailed = createAction(APPLICATION_MODULE + SMEV_CHECK_APPLICATION + FAILED);

export const smevCheckAllApplication = createDeferredAction(APPLICATION_MODULE + SMEV_CHECK_ALL_APPLICATION);
export const smevCheckAllApplicationSuccessful = createAction(APPLICATION_MODULE + SMEV_CHECK_ALL_APPLICATION + SUCCESSFUL);
export const smevCheckAllApplicationFailed = createAction(APPLICATION_MODULE + SMEV_CHECK_ALL_APPLICATION + FAILED);

export const loadApplicationHistory = createDeferredAction(APPLICATION_MODULE + LOAD_APPLICATION_HISTORY);
export const loadApplicationHistorySuccessful = createAction(APPLICATION_MODULE + LOAD_APPLICATION_HISTORY + SUCCESSFUL);
export const loadApplicationHistoryFailed = createAction(APPLICATION_MODULE + LOAD_APPLICATION_HISTORY + FAILED);

export const loadAwaitDocument = createDeferredAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT);
export const loadAwaitDocumentBegin = createDeferredAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT + BEGIN);
export const loadAwaitDocumentSuccessful = createAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT + SUCCESSFUL);
export const loadAwaitDocumentFailed = createAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT + FAILED);
export const loadAwaitDocumentClear = createAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT + CLEAR);

export const loadDocumentById = createDeferredAction(APPLICATION_MODULE + LOAD_DOCUMENT_BY_ID);
export const loadDocumentByIdSuccessful = createAction(APPLICATION_MODULE + LOAD_DOCUMENT_BY_ID + SUCCESSFUL);
export const loadDocumentByIdFailed = createAction(APPLICATION_MODULE + LOAD_DOCUMENT_BY_ID + FAILED);

export const deleteDocument = createDeferredAction(APPLICATION_MODULE + DELETE_DOCUMENT);
export const deleteDocumentSuccessful = createAction(APPLICATION_MODULE + DELETE_DOCUMENT + SUCCESSFUL);
export const deleteDocumentFailed = createAction(APPLICATION_MODULE + DELETE_DOCUMENT + FAILED);

export const groupSignFile = createDeferredAction(APPLICATION_MODULE + GROUP_SIGN_FILE);
export const groupSignFileSuccessful = createAction(APPLICATION_MODULE + GROUP_SIGN_FILE + SUCCESSFUL);
export const groupSignFileFailed = createAction(APPLICATION_MODULE + GROUP_SIGN_FILE + FAILED);

export const groupDeleteFile = createDeferredAction(APPLICATION_MODULE + GROUP_DELETE_FILE);
export const groupDeleteFileSuccessful = createAction(APPLICATION_MODULE + GROUP_DELETE_FILE + SUCCESSFUL);
export const groupDeleteFileFailed = createAction(APPLICATION_MODULE + GROUP_DELETE_FILE + FAILED);

export const reviewApplication = createDeferredAction(APPLICATION_MODULE + REVIEW_APPLICATION);
export const reviewApplicationSuccessful = createAction(APPLICATION_MODULE + REVIEW_APPLICATION + SUCCESSFUL);
export const reviewApplicationFailed = createAction(APPLICATION_MODULE + REVIEW_APPLICATION + FAILED);

export const generateDocx = createDeferredAction(APPLICATION_MODULE + GENERATE_DOCX);
export const generateDocxSuccessful = createAction(APPLICATION_MODULE + GENERATE_DOCX + SUCCESSFUL);
export const generateDocxFailed = createAction(APPLICATION_MODULE + GENERATE_DOCX + FAILED);

export const applicationFieldsValidation = createDeferredAction(APPLICATION_MODULE + APPLICATION_FIELDS_VALIDATION);
export const applicationFieldsValidationSuccessful = createAction(APPLICATION_MODULE + APPLICATION_FIELDS_VALIDATION + SUCCESSFUL);
export const applicationFieldsValidationFailed = createAction(APPLICATION_MODULE + APPLICATION_FIELDS_VALIDATION + FAILED);
export const applicationFieldsValidationClear = createAction(APPLICATION_MODULE + APPLICATION_FIELDS_VALIDATION + CLEAR);

export const loadLegalEntityFormList = createDeferredAction(APPLICATION_MODULE + LOAD_LEGAL_ENTITY_FORM_LIST);
export const loadLegalEntityFormListSuccessful = createAction(APPLICATION_MODULE + LOAD_LEGAL_ENTITY_FORM_LIST + SUCCESSFUL);
export const loadLegalEntityFormListFailed = createAction(APPLICATION_MODULE + LOAD_LEGAL_ENTITY_FORM_LIST + FAILED);

export const searchInfoByParam = createDeferredAction(APPLICATION_MODULE + SEARCH_INFO_BY_PARAM);
export const searchInfoByParamSuccessful = createAction(APPLICATION_MODULE + SEARCH_INFO_BY_PARAM + SUCCESSFUL);
export const searchInfoByParamFailed = createAction(APPLICATION_MODULE + SEARCH_INFO_BY_PARAM + FAILED);
export const searchInfoByParamClear = createAction(APPLICATION_MODULE + SEARCH_INFO_BY_PARAM + CLEAR);

export const loadApplicationIdList = createDeferredAction(APPLICATION_MODULE + LOAD_LIST_ID);
export const loadApplicationIdListBegin = createDeferredAction(APPLICATION_MODULE + LOAD_LIST_ID + BEGIN);
export const loadApplicationIdListSuccessful = createAction(APPLICATION_MODULE + LOAD_LIST_ID + SUCCESSFUL);
export const loadApplicationIdListFailed = createAction(APPLICATION_MODULE + LOAD_LIST_ID + FAILED);

export const loadAwaitDocumentIdList = createDeferredAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENTS_LIST_ID);
export const loadAwaitDocumentIdListBegin = createDeferredAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENTS_LIST_ID + BEGIN);
export const loadAwaitDocumentIdListSuccessful = createAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENTS_LIST_ID + SUCCESSFUL);
export const loadAwaitDocumentIdListFailed = createAction(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENTS_LIST_ID + FAILED);

export const exportApplication = createDeferredAction(APPLICATION_MODULE + EXPORT_APPLICATION);
export const exportApplicationSuccessful = createAction(APPLICATION_MODULE + EXPORT_APPLICATION + SUCCESSFUL);
export const exportApplicationFailed = createAction(APPLICATION_MODULE + EXPORT_APPLICATION + FAILED);

export const loadApplicantList = createDeferredAction(APPLICATION_MODULE + LOAD_APPLICANT_LIST);
export const loadApplicantListBegin = createDeferredAction(APPLICATION_MODULE + LOAD_APPLICANT_LIST + BEGIN);
export const loadApplicantListSuccessful = createAction(APPLICATION_MODULE + LOAD_APPLICANT_LIST + SUCCESSFUL);
export const loadApplicantListFailed = createAction(APPLICATION_MODULE + LOAD_APPLICANT_LIST + FAILED);

export const loadRepresentativeList = createDeferredAction(APPLICATION_MODULE + LOAD_REPRESENTATIVE_LIST);
export const loadRepresentativeListBegin = createDeferredAction(APPLICATION_MODULE + LOAD_REPRESENTATIVE_LIST + BEGIN);
export const loadRepresentativeListSuccessful = createAction(APPLICATION_MODULE + LOAD_REPRESENTATIVE_LIST + SUCCESSFUL);
export const loadRepresentativeListFailed = createAction(APPLICATION_MODULE + LOAD_REPRESENTATIVE_LIST + FAILED);

export const acceptApplicant = createDeferredAction(APPLICATION_MODULE + ACCEPT_APPLICANT);
export const acceptApplicantSuccessful = createAction(APPLICATION_MODULE + ACCEPT_APPLICANT + SUCCESSFUL);
export const acceptApplicantFailed = createAction(APPLICATION_MODULE + ACCEPT_APPLICANT + FAILED);

export const applicationBatchCommand = createDeferredAction(APPLICATION_MODULE + BATCH_COMMAND);
export const applicationBatchCommandSuccessful = createAction(APPLICATION_MODULE + BATCH_COMMAND + SUCCESSFUL);
export const applicationBatchCommandFailed = createAction(APPLICATION_MODULE + BATCH_COMMAND + FAILED);

export const loadPreviewDocument = createDeferredAction(APPLICATION_MODULE + LOAD_PREVIEW_DOCUMENT);
export const loadPreviewDocumentSuccessful = createAction(APPLICATION_MODULE + LOAD_PREVIEW_DOCUMENT + SUCCESSFUL);
export const loadPreviewDocumentFailed = createAction(APPLICATION_MODULE + LOAD_PREVIEW_DOCUMENT + FAILED);

export const registerMaisEgu = createDeferredAction(APPLICATION_MODULE + REGISTER_MAIS_EGU);
export const registerMaisEguSuccessful = createAction(APPLICATION_MODULE + REGISTER_MAIS_EGU + SUCCESSFUL);
export const registerMaisEguFailed = createAction(APPLICATION_MODULE + REGISTER_MAIS_EGU + FAILED);

export const getHistoryMaisEguById = createDeferredAction(APPLICATION_MODULE + MAIS_EGU_HISTORY);
export const getHistoryMaisEguByIdSuccessful = createAction(APPLICATION_MODULE + MAIS_EGU_HISTORY + SUCCESSFUL);
export const getHistoryMaisEguByIdFailed = createAction(APPLICATION_MODULE + MAIS_EGU_HISTORY + FAILED);
